import React from 'react';

type Props = {
    title: string;
    subTitle: string;
    backgroundImageURL: string;
};

const TopBanner: React.FC<Props> = ({
    title,
    subTitle,
    backgroundImageURL,
}: Props) => {
    return (
        <div
            className="w-full py-32 bg-cover bg-no-repeat bg-center"
            style={{
                backgroundImage: `url(${backgroundImageURL})`,
            }}
        >
            <div className="container text-white text-center m:text-left text-shadow">
                <h3 className="text-5xl font-light">{title}</h3>

                <div className="h-divider"></div>

                <p>{subTitle}</p>
            </div>
        </div>
    );
};

export default TopBanner;
